module.exports = __webpack_public_path__ + "img/markets_x2.cd45bc54.png";